import { render } from "./PublicSiteFooter.vue?vue&type=template&id=d580be20&scoped=true"
import script from "./PublicSiteFooter.vue?vue&type=script&lang=js"
export * from "./PublicSiteFooter.vue?vue&type=script&lang=js"

import "./PublicSiteFooter.vue?vue&type=style&index=0&id=d580be20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d580be20"]])

export default __exports__